<template>
  <router-view></router-view>
</template>

<script setup>
import {onMounted} from "vue";
import router from './router'
import {deviceType} from "./common/js/const"
onMounted(() => {
  let system = deviceType();
  if (system === "wap") {
      console.log("onMounted", location.href)
      if (location.href.indexOf("/pc") === -1) {
          location.href = location.origin + process.env.VUE_APP_BASE_PATH + "wap/";
          return;
      }
    location.href = location.href.replace("pc", "wap")
  }
})
</script>